import { render, staticRenderFns } from "./infoList3.vue?vue&type=template&id=3ecbd1d0&scoped=true&"
import script from "./infoList3.vue?vue&type=script&lang=js&"
export * from "./infoList3.vue?vue&type=script&lang=js&"
import style0 from "./infoList3.vue?vue&type=style&index=0&id=3ecbd1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbd1d0",
  null
  
)

export default component.exports